import Axios, { AxiosRequestConfig } from 'axios';

export const YqBaseUrl = 'https://yqms.istarshine.com/v4/';

async function request(options: Partial<AxiosRequestConfig>) {
  const data = await Axios.request({
    // baseURL: YqBaseUrl,
    headers: {
      // Token: 'NWQxZWZjZTI4NTRmNDIxYTgzYTA4OWM3MjhhZmQ3NGRfNzUxMTU=',
    },
    ...options,
  });

  if (data.data.code !== 200) {
    throw new Error(data.data.message);
  } else {
    return data.data.data;
  }
}

export type SearchAllParams = {
  keywords: string;
  pageSize?: number;
  offset?: number;
  excludeWord: string;
  searchMode: any;
  timeRange: any;
  typeList: string[];
  beginTime?: number | null;
  endTime?: number | null;
};

export class YqApi {
  static searchAll({
    keywords,
    excludeWord,
    searchMode,
    timeRange,
    typeList,
    beginTime,
    endTime,
    pageSize,
    offset,
  }: SearchAllParams) {
    return request({
      url: '/v4/api/search/all2',
      method: 'POST',
      data: {
        timeRange: timeRange,
        beginTime: beginTime,
        endTime: endTime,
        attitude: [],
        sourceRange: '',
        typeList: typeList,
        mediaType: [],
        isOcr: '',
        weiboType: [],
        weiboAttestType: [],
        weiboState: '',
        customCondition: [],
        keywords,
        pageSize,
        secondKeywords: '',
        secondTypeList: ['content', 'title', 'author', 'site', 'comment', 'mcn', 'post_place', 'ip_region'],
        searchMode,
        infoSource: '',
        isCoutSearchNum: '',
        sites: [],
        orderBy: 1,
        isRepeat: '1',
        distinguishType: [],
        videoDurationType: [],
        regionalMatchType: [],
        regionalMatch: [],
        hotType: ['1', '4', '3', '5'],
        platformRankType: [
          '2',
          '3',
          '6',
          '7',
          '8',
          '4',
          '9',
          '11',
          '10',
          '14',
          '15',
          '16',
          '30',
          '31',
          '32',
          '33',
          '34',
        ],
        cityRankType: ['20', '22', '21', '23'],
        industryRankType: ['1', '2', '9', '23', '36', '49', '73'],
        excludeWord: excludeWord,
        fansCountRange: '',
        imgOrderBy: 9,
        offset,
        imgOffset: 0,
        modelType: 0,
        limitNum: pageSize,
        sessionId: 32480,
        textEsTaskId: '',
        imgEsTaskId: '',
        sceneDescription: '',
        timestamp: Date.now(),
        sceneType: '',
        trackTotalHits: false,
      },
    });
  }

  static mediaCount({
    keywords,
    excludeWord,
    searchMode,
    timeRange,
    typeList,
    pageSize,
    beginTime,
    endTime,
    offset,
  }: SearchAllParams) {
    return request({
      url: '/v4/api/search/all/mediaCount',
      method: 'POST',
      data: {
        timeRange: timeRange,
        beginTime: beginTime,
        endTime: endTime,
        attitude: [],
        sourceRange: '',
        typeList: typeList,
        mediaType: [],
        isOcr: '',
        weiboType: [],
        weiboAttestType: [],
        weiboState: '',
        customCondition: [],
        keywords,
        pageSize,
        secondKeywords: '',
        secondTypeList: ['content', 'title', 'author', 'site', 'comment', 'mcn', 'post_place', 'ip_region'],
        searchMode,
        infoSource: '',
        isCoutSearchNum: '',
        sites: [],
        orderBy: 1,
        isRepeat: '1',
        distinguishType: [],
        videoDurationType: [],
        regionalMatchType: [],
        regionalMatch: [],
        hotType: ['1', '4', '3', '5'],
        platformRankType: [
          '2',
          '3',
          '6',
          '7',
          '8',
          '4',
          '9',
          '11',
          '10',
          '14',
          '15',
          '16',
          '30',
          '31',
          '32',
          '33',
          '34',
        ],
        cityRankType: ['20', '22', '21', '23'],
        industryRankType: ['1', '2', '9', '23', '36', '49', '73'],
        excludeWord: excludeWord,
        fansCountRange: '',
        imgOrderBy: 9,
        offset,
        imgOffset: 0,
        modelType: 0,
        limitNum: pageSize,
        sessionId: 32480,
        textEsTaskId: '',
        imgEsTaskId: '',
        sceneDescription: '',
        timestamp: Date.now(),
        sceneType: '',
        trackTotalHits: false,
      },
    });
  }

  static detail(id: string, { keywords, index }: { keywords: string; index: string }) {
    return request({
      // url: `/v4/api/search/info/detail/${id}`,
      url: `/v4/api/subject/info/${id}`,
      method: 'GET',
      params: {
        timeType: 1,
        subjectModule: undefined,
        mediaType: undefined,
        isSearch: true,
        index: index,
        keywords: keywords,
        isRead: 1,
        subjectId: undefined,
        isAll: true,
      },
    });
  }
}
